import createStore from '../../../redux/factories/crud/crudFactory';
import {templateReducers} from './reducers';
import templateSaga from './saga';

const {actionTypes, actions, reducers, sagas} = createStore('api/v2/templates');

export {actionTypes, actions, reducers, sagas, templateReducers, templateSaga};
